import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../lib/domain';
import { BasicHeader } from '../../components/basic_header';
import ErrorWrapper from '../../lib/error_wrapper';
import FilterFixedInput from '../../components/filter_fixed_input';
import { Select, DatePicker, Table, Divider, Button, Spin, message, Popconfirm, Tooltip, Space } from 'antd';
import NetworkSelect from '../../lib/ui/network_select';
import moment from 'moment';
import { CustomStats } from '../../components/custom_stat';
import { GetAppOutlined, KitchenOutlined, Refresh, MenuOpenOutlined, VisibilityOutlined } from '@material-ui/icons'
import { COLORS } from '../theme';
import { Link } from 'react-router-dom';
import { activity_quick_menu } from '../../util/ui_util';
import { TransparentButton, TextTag } from '../../components/basic_items';
import { formatMoney, defaultDateFormat, showErrorInNotification, copyStringToClipboard, showSuccessInNotification } from '../../lib/util';
import CustomDateRangePicker from '../../components/custom_date_range';
import { PopUpForm } from '../../lib/ui/popupform';
import DayDifferennceTag from '../../components/day_difference_tag';


const queryString = require('query-string');

class FetcherResponses extends Component {
  constructor(props) {
    super(props)
    this.repository_id = props.match.params.repository_id;


    this.state = {
      filter_query: {

      },
      loading: true,
      repository_obj: {},
      selected_data: {},
      re_run_modal: false,
      form_data: {},
      reprocessed_file_ids: [],
      reprocessing_id: null
    }


    this.detail_repository = RESTExecutor.detail().forId(this.repository_id).config({
      label: 'repository_detail'
    }).callbacks((success) => {
      this.setState({
        loading: false, repository_obj: success.result
      });
      this.list_fetcher_responses.config({
        params: {
          ...this.state.filter_query
        }
      }).execute();

    }, (error) => {
      this.setState({
        loading: false
      })
    }).connect(props.domains.fetcher);

    this.list_fetcher_responses = RESTExecutor.list().config({
      label: 'fetcher_responses',
      params: {}
    }).connect(props.domains.fetcher);

    this.delete_fetcher_response=RESTExecutor.delete().config({
      label:'fetcher_responses_detail',
      params:{}
    }).callbacks((success)=>{
        this.list_fetcher_responses.execute();
        showSuccessInNotification(success,"Response deleted");
    },(error)=>{
      showErrorInNotification(error);
    }).connect(props.domains.fetcher);


    this.untransfer_fetcher_response=RESTExecutor.post().config({
      label:'untransfer_response',
      params:{}
    }).callbacks((success)=>{
        showSuccessInNotification(success,"Response Untransferred");
    },(error)=>{
      showErrorInNotification(error);
    }).connect(props.domains.fetcher);

    this.download_response = RESTExecutor.detail().config({
      label: 'download_responses'
    }).callbacks((success) => {
      window.open(success.result.url, '_blank');
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.fetcher);

    this.download_transaction = RESTExecutor.detail().config({
      label: 'transaction_download'
    }).callbacks((success) => {
      window.open(success.result.url, '_blank');
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.fetcher);

    this.re_run = RESTExecutor.post().config({
      label: 'rerun_responses'
    }).callbacks((success) => {
      message.success(success.result.message || "Running selector.");
      this.setState({
        selected_data: {},
        re_run_modal: false,
        form_data: {}
      })
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.fetcher);


    this.reprocess_file = RESTExecutor.post().config({
      label: 'file_reprocess',
      params: {}
    }).callbacks((success) => {
      try {
        this.loading_message();
      } catch (e) {

      }
      let reprocessing_id = this.state.reprocessing_id;
      let new_reprocessed_file_ids = this.state.reprocessed_file_ids;
      new_reprocessed_file_ids.push(reprocessing_id);
      this.setState({
        reprocessed_file_ids: new_reprocessed_file_ids,
        reprocessing_id: null
      })

      message.success(success.result.message || "Reprocessing File");
    }, (error) => {
      try {
        this.loading_message();
      } catch (e) {


      }
      this.setState({
        reprocessing_id: null
      })
      showErrorInNotification(error);
    }).connect(props.domains.activity);


  }

  reRun = (data) => {

    this.re_run.forId(this.state.selected_data.response_id).execute(data);
    // Rerun for given responses
  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }
  render() {
    const { filter_query, loading, repository_obj, selected_data, reprocessed_file_ids, reprocessing_id } = this.state;
    let detail_repository_resp = this.detail_repository.response();

    if (loading) {
      return <center><Spin /></center>
    }

    let list_fetcher_responses_resp = this.list_fetcher_responses.response();
    let list_fetcher_responses_data = list_fetcher_responses_resp.result || {};
    let rowsData = list_fetcher_responses_data.rows || [];
    let rowsMeta = list_fetcher_responses_resp.meta || {};

    let re_run_resp = this.re_run.response();

    const required_fields = [
      { filterable: true, index: 'selectors', name: "Selector", help_text: "Which selector to run for given file.", type: 'networkselect', url: `/fetcher-responses/${selected_data.response_id}/selectors`, mode: 'tags' }
    ]

    return (
      <ErrorWrapper
        error={detail_repository_resp}
        onReload={() => {
          this.setState({ loading: true })
          this.detail_repository.execute();
        }}>


        <BasicHeader
          title={repository_obj.name}
          titleTyppe="Repository"
          subtitle="Responses"
          right={[
            <Link to={`/activity/fetcher/${this.repository_id}/logs`} >
              <TransparentButton
                label="Logs"
                icon={<KitchenOutlined />}
                hint="View Logs"
              />
            </Link>
          ]}
        />

        <PopUpForm
          width="60%"
          key={`${selected_data.id}rerun`}
          title={"Selector to Rerun"}
          show_title_only
          forCreate={true}
          initialData={this.state.form_data}
          fields={required_fields}
          open={this.state.re_run_modal}
          networkState={re_run_resp}
          onClose={() => {
            console.log("closing upload form")
            this.setState({
              re_run_modal: false,
              selected_data: {},
              form_data: {}
            })
          }
          }
          onSubmit={(data) => {
            console.log("DATA", data);
            this.reRun(data);
          }}
        />

        <div className='filter-card'>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            // justifyContent: 'space-between',
            flexWrap: 'wrap',
            paddingTop: 4, paddingBottom: 4
          }}>
            <FilterFixedInput label="Execution Date">
              <CustomDateRangePicker
                style={{
                  // width: 400,
                  // marginLeft: 16,
                  flex: null
                }}
                startDate={filter_query.dateFrom ? moment(filter_query.dateFrom, defaultDateFormat) : null}
                endDate={filter_query.dateTo ? moment(filter_query.dateTo, defaultDateFormat) : null}
                onChange={(dates) => {
                  //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                  this.stateUpdater({
                    stateKey: 'filter_query', appendObj: {
                      dateFrom: dates.startDate.format(defaultDateFormat),
                      dateTo: dates.endDate.format(defaultDateFormat), page: 1
                    },
                    callback: () => {
                      this.props.history.push({
                        search: queryString.stringify(this.state.filter_query)
                      })
                    }
                  })
                }}

              />
              {/* <DatePicker
                placeholder="Select Date"
                value={filter_query.executed_at ? moment(filter_query.executed_at, "YYYY-MM-DD") : null}
                format="YYYY-MM-DD"
                onChange={(date, dateString) => {
                  this.stateUpdater({
                    stateKey: 'filter_query', valueKey: 'executed_at', value: date ? dateString : null, callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.filter_query, page: 1 })
                      })
                    }
                  });
                }
                }
                style={{ }} /> */}
            </FilterFixedInput>
            {/* <FilterFixedInput label="Response">
              <Select
                allowClear
                showSearch
                className={filter_query.has_response != null ? 'filter-option-selected' : ''}
                style={{
                }}
                placeholder="Empty/Non Empty"
                value={filter_query.has_response}
                // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onChange={(value, e) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'has_response',
                    value: value,
                    callback: () => {
                      this.props.history.push({
                        // pathname:"users",
                        search: queryString.stringify({ ...this.state.filter_query, per_page: 10, page: 1 })
                      })
                    }
                  });
                }}
              >
                <Select.Option value={'false'}>
                  Empty
                  </Select.Option>
                <Select.Option value={'true'}>
                  Non-empty
                  </Select.Option>
              </Select>
            </FilterFixedInput> */}

          </div>
        </div>

        <ErrorWrapper
          error={list_fetcher_responses_resp}
          onReload={() => {
            this.list_fetcher_responses.execute()
          }}>
          <div
          >
            <Table
              loading={list_fetcher_responses_resp.fetching}
              dataSource={rowsData}
              showHeader={false}
              className='noHover no-separator-table single-column no-padding-table'
              columns={[
                {
                  dataIndex: '',
                  render: (data) => {
                    return <FetcherResponseItem
                    onUntransfer={(data)=>{
                      this.untransfer_fetcher_response.forId(data.response_id).execute();
                    }}
                      onRerun={(data) => {
                        this.setState({
                          selected_data: data,
                          re_run_modal: true
                        })
                      }}
                      onDelete={(data)=>{
                        this.delete_fetcher_response.config({
                          params:{
                            repository_id:this.repository_id,
                            response_id:data.response_id
                          }
                        }).execute();
                      }}
                      onDownload={(data) => {
                        this.download_response.forId(data.response_id).execute()
                      }}
                      onDownloadTransaction={(data) => {
                        this.download_transaction.forId(data.id).config({
                          params: {
                            data_type_id: data.data_type_id
                          }
                        }).execute()
                      }}
                      repository_id={this.repository_id}
                      data={data}
                      reprocessed_list={[...reprocessed_file_ids, reprocessing_id]}
                      onReprocessFile={(file_id, response_id, file_name = '') => {
                        this.loading_message = message.loading(`Reprocessing ${file_name}`, 0);
                        this.setState({
                          reprocessing_id: file_id
                        })
                        this.reprocess_file.config({
                          params: {
                            response_id: response_id,
                            file_id: file_id
                          }
                        }).execute();
                      }}

                    />
                  }

                }
              ]}
              pagination={{
                simple: false,
                size: 'small',
                position: 'bottom',
                onChange: (current, size) => {
                  this.props.history.push({
                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                  })
                },
                defaultCurrent: 1,
                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                pageSize: (rowsMeta && rowsMeta.requested_count),
                total: (rowsMeta && rowsMeta.total_count > 10000 ? 10000 : rowsMeta.total_count),
                showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${rowsMeta.total_count > 10000 ? `10,000+` : formatMoney(rowsMeta.total_count, 0)} items`
              }}
            />
          </div>
        </ErrorWrapper>
      </ErrorWrapper>
    );
  }

  componentDidMount() {

    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 50,
        page: 1,
        ...new_filter_query,
        repository_id: this.repository_id
      }
    }, () => {
      this.detail_repository.execute()
    })

    // this.list_fetcher_logs.execute()
  }


  componentWillReceiveProps(nextProps) {
    var oldrepository_id = this.props.match.params.repository_id;
    var newrepository_id = nextProps.match.params.repository_id;


    if (oldrepository_id !== newrepository_id || (
      this.props.location && (this.props.location.search !== nextProps.location.search)
    )) {
      this.repository_id = newrepository_id;
      const parsed = queryString.parse(nextProps.location.search);
      this.setState({
        filter_query: {
          per_page: 50,
          page: 1,
          ...parsed,
          repository_id: this.repository_id
        },
      }, () => {
        if (oldrepository_id !== newrepository_id) {
          this.setState({
            loading: true
          }, () => {
            this.detail_repository.forId(this.repository_id).execute()
          })
        } else {
          this.list_fetcher_responses.config({
            params: {
              ...this.state.filter_query
            }
          }).execute()
        }
      })

    }
  }
}

export default withDomains(FetcherResponses, "fetcher", "activity");




const FetcherResponseItem = (props) => {
  let data = props.data || {};
  let responses = data.files || [];
  let repository_id = props.repository_id;
  let reprocessed_list = props.reprocessed_list || []
  // let total_responses_count=data.response_count;

  return <div className='default-card' style={{
    margin: 0,
    marginTop: 4, marginBottom: 4
  }}>

    <div style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingTop: 16,
      paddingLeft: 20, paddingRight: 20,
      paddingBottom: 16,
      alignItems: 'center'
    }}>
      {/* <div style={{ minWidth: 300, width: '29%' }}>
        <CustomStats label={`REPOSITORY NAME`} title={data.repository_name} titleStyle={{
          fontWeight: 'normal',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden'
        }} />
      </div> */}
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }}>
        <Space size={20}>
          <div className='credit-circle'>{data.manual == true ? "M" : "A"}</div>
          <DayDifferennceTag date={data.executed_at} />
          <div className='description-text' style={{
            fontWeight: 'bold'
          }}>{data.file_name}</div>


        </Space>
      </div>


      <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }}>
        <Space size={40}>
          {/* <TextTag type={data.status == "Completed" ? "success" :
            data.status == "Error" ? 'danger' : 'warning'
          } label={(data.status || "").toUpperCase()} /> */}


          <div style={{
            display: 'flex', flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <Popconfirm
              title="Are you sure to delete this response?"
              onConfirm={() => {
                typeof props.onDelete === 'function' && props.onDelete(data)
              }}
              okText="Yes"
              cancelText="No"
            >

              <Button title="Delete"

                onClick={() => {
                  // typeof props.onRerun === 'function' && props.onRerun(data)
                }}
                size='small'
                style={{
                  padding: 0,
                  color: COLORS.danger_primary

                }} type='link'>Delete</Button>
            </Popconfirm>
            <Divider type='vertical' />
            <Popconfirm
              title="Are you sure to untransfer this response?"
              onConfirm={() => {
                typeof props.onUntransfer === 'function' && props.onUntransfer(data)
              }}
              okText="Yes"
              cancelText="No"
            >
            <Button title="Untransfer"
              size='small'
              style={{
                padding: 0
              }} type='link'>Untransfer</Button>
              </Popconfirm>
            <Divider type='vertical' />

<Button title="Rerun"
  onClick={() => {
    typeof props.onRerun === 'function' && props.onRerun(data)
  }}
  size='small'
  style={{
    padding: 0
  }} type='link'>Re-run</Button>
            <Divider type='vertical' />
            <GetAppOutlined
              style={{
                marginLeft: 8
              }}
              onClick={() => {
                typeof props.onDownload === 'function' && props.onDownload(data)
              }}
              titleAccess="Download File" className='basic-icon hand-cursor' />
            <Divider type='vertical' />
            <Link to={{
              pathname: `/activity/fetcher/logs/${data.fetcher_log_id}`,
            }}>
              <KitchenOutlined
                titleAccess='Go To Log'
                className='basic-icon hand-cursor'
              /></Link>
          </div>
        </Space>
      </div>




    </div>

    {/* <Divider style={{ marginTop: 0, marginBottom: 0 }} /> */}

    {responses.length == 0 ?
      <div style={{
        paddingLeft: 16,
        paddingTop: 8,
        paddingBottom: 8,
        borderTop: `1px solid ${COLORS.border_basic}`
      }}>
        <span className='stat-subtitle'>No files selected</span>
      </div>
      :
      <Table
        dataSource={responses}
        className='small-table separator-table'
        size='small'
        bordered
        style={{
          backgroundColor: 'rgba(229, 229, 229, 0.2)'
        }}
        pagination={false}
        rowClassName={(record) => {
          // console.log("record",record);
          return record.data_type_processed == false ? 'no-selector-row' :
            record.selector_success == false ? 'error-row-1' : ''
        }}
        columns={[
          {
            title: "File",
            dataIndex: 'file_uri',
            key: 'file_uri',
            className: 'word-break',
            // width: 200,
            render: (file_name, record) => {
              let has_run = record.file_processed === false || (record.file_processed == true && record.processing_error == true);
              return record.data_type_processed == false ? <span>Selector not applied</span> :
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                }}>
                  {record.error_message ?
                    <Tooltip title={<div className='log-text'>
                      {(record.error_message || "Error Message not available")}
                    </div>}
                      placement='bottomRight'
                      arrowPointAtCenter
                      autoAdjustOverflow
                      overlayClassName={record.error_message ? 'error-tooltip side-scroll' : ''}
                    >
                      <div
                        onClick={(e) => {
                          copyStringToClipboard(record.error_message);
                          message.success("Copied")
                        }}
                        className='hand-cursor dot-indicator danger' style={{
                          marginRight: 8
                        }}>
                      </div></Tooltip>
                    :
                    <div className={`dot-indicator ${record.error ? 'danger' : ''}`} style={{
                      marginRight: 8
                    }}></div>
                  }
                  {file_name ?
                    // <Link style={{
                    //   display: 'flex',
                    //   alignItems: 'center'
                    // }} to={`/activity/data-type/${record.data_type_id}/files/${record.id}/view`}>
                    <span>
                      {file_name}
                    </span>
                    // </Link> 
                    :
                    !record.data_type_processed ? <span>Selector not applied yet</span> :
                      record.error == true && record.selector_success == false ? <span>Error while Applying Selector</span> :
                        <span>No File Extracted</span>}

                  {/* <span>{file_name || "No File Extracted"}</span> */}



                  {has_run && !reprocessed_list.includes(record.id) && <Popconfirm
                    onConfirm={() => {
                      typeof props.onReprocessFile === 'function' && props.onReprocessFile(record.id, record.fetcher_response_id, file_name)
                    }}
                    title="Are you sure you want to run this file?">
                    <Refresh className='hand-cursor'
                      titleAccess="Rerun"
                      style={{
                        height: 20,
                        color: COLORS.primary,
                        width: 20,
                        // border:'1px solid',
                        // borderRadius:'50%',
                        marginLeft: 8
                      }} /></Popconfirm>}

                </div>
            }

          },
          {
            dataIndex: 'file_uri',
            width: 40,
            align: 'center',
            render: (file_name, record) => {
              if (file_name) {
                return <Link style={{
                  display: 'flex',
                  alignItems: 'center'
                }} to={`/activity/data-type/${record.data_type_id}/files/${record.id}/view`}>
                  <VisibilityOutlined />
                </Link>
              } else {
                return <div></div>
              }
            }
          },
          {
            title: "DATATYPE",
            dataIndex: 'data_type',
            key: 'data_type',
            className: 'word-break',
            render: (value, record) => {
              let has_run = false;
              return <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}>
                <span>{value}</span>
                {has_run && <Popconfirm title="Are you sure you want to run this file?">
                  <Refresh className='hand-cursor'
                    titleAccess="Rerun"
                    style={{
                      height: 20,
                      color: COLORS.primary,
                      width: 20,
                      // border:'1px solid',
                      // borderRadius:'50%',
                      marginLeft: 8
                    }} /></Popconfirm>
                }
              </div>
            }
          },
          {
            title: "Pipeline ",
            className: 'pipeline-cols',
            children: [
              {
                title: "Blocks",
                width: 100,
                key: 'blocks_count',
                dataIndex: 'blocks_count',
                className: 'pipeline-cols center-align',
                render: (success_count = 0, record) => success_count == null ? <span className='right-align'>-</span> :
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}>{record.file_processed == true && record.processing_error == true && success_count > 0 ? <Link to={{
                    pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                    search: queryString.stringify({
                      // success_type:1
                    })
                  }}>
                    <span className='right-align'>{formatMoney(success_count, 0)}</span>
                  </Link> :
                    <span className='right-align'>{formatMoney(success_count, 0)}</span>
                    }</div>
              },
              {
                title: "Parser",
                width: 100,
                key: 'Parser',
                className: 'pipeline-cols center-align',
                render: (record) => {
                  let success_count = record.parsing_success;
                  let error_count = record.parsing_error;
                  let obj = {
                    children: record.show_dash == true ? <span className='right-align'>-</span> : <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}>

                      {error_count > 0 ? <Link to={{
                        pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                        search: queryString.stringify({
                          status: 'error',
                          error_type: 1
                        })
                      }}>
                        <span className='error-text'>{formatMoney(success_count, 0)} (-{formatMoney(error_count, 0)})</span>
                      </Link> :
                        <span className='right-align'>{formatMoney(success_count, 0)}</span>
                      }
                    </div>,
                    props: {
                      className: record.show_dash == true ? '' : error_count > 0 ? 'pipeline-error-cell' : 'pipeline-success-cell'
                    }
                  }
                  return obj;
                }
              },
              {
                title: "Normalizer",
                width: 100,
                key: 'Normalizer',
                className: 'pipeline-cols center-align',
                render: (record) => {
                  let success_count = record.normalization_success;
                  let error_count = record.normalization_error;
                  let obj = {
                    children: record.show_dash == true ? <span className='right-align'>-</span> : <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}>

                      {error_count > 0 ? <Link to={{
                        pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                        search: queryString.stringify({
                          status: 'error',
                          error_type: 2
                        })
                      }}>
                        <span className='error-text'>{formatMoney(success_count, 0)} (-{formatMoney(error_count, 0)})</span>
                      </Link> :
                        <span className='right-align'>{formatMoney(success_count, 0)}</span>
                      }
                    </div>,
                    props: {
                      className: record.data_type_processed == false || record.selector_success == false || (record.file_processed == false) ? '' : error_count > 0 ? 'pipeline-error-cell' : 'pipeline-success-cell'
                    }
                  }
                  return obj;
                }

              },
              // {
              //   title: "Classifier",
              //   width: 88,
              //   key: 'Classifier',
              //   render: (record) => {
              //     let success_count = record.classification_success;
              //     let error_count = record.classification_error;
              //     return record.data_type_processed == false ? <span className='right-align'>-</span> : <div style={{
              //       display: 'flex',
              //       flexDirection: 'column',
              //       alignItems: 'flex-end'
              //     }}>
              //       {record.file_processed == false && success_count > 0 ? <Link to={{

              //         pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
              //         search: queryString.stringify({
              //           success_type: 3
              //         })
              //       }}>
              //         <span className='right-align'>{formatMoney(success_count, 0)}</span>
              //       </Link> :
              //         <span className='right-align'>{formatMoney(success_count, 0)}</span>
              //       }
              //       {error_count > 0 && record.file_processed == false &&
              //         <Link to={{
              //           pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
              //           search: queryString.stringify({
              //             status: 'error',
              //             error_type: 3
              //           })
              //         }}>
              //           <span className='error-text'>{formatMoney(error_count, 0)} Errors</span>
              //         </Link>}</div>
              //   }
              // },
              // {
              //   title: "Extractor",
              //   width: 90,
              //   key: 'Extractor',
              //   render: (record) => {
              //     let success_count = record.extraction_success;
              //     let error_count = record.extraction_error;
              //     return record.data_type_processed == false ? <span className='right-align'>-</span> : <div style={{
              //       display: 'flex',
              //       flexDirection: 'column',
              //       alignItems: 'flex-end'
              //     }}>
              //       {record.file_processed == false && success_count > 0 ? <Link to={{

              //         pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
              //         search: queryString.stringify({
              //           success_type: 4
              //         })
              //       }}>
              //         <span className='right-align'>{formatMoney(success_count, 0)}</span>
              //       </Link> :
              //         <span className='right-align'>{formatMoney(success_count, 0)}</span>
              //       }
              //       {error_count > 0 && record.file_processed == false &&
              //         <Link to={{
              //           pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
              //           search: queryString.stringify({
              //             status: 'error',
              //             error_type: 4
              //           })
              //         }}>
              //           <span className='error-text'>{formatMoney(error_count, 0)} Errors</span>
              //         </Link>}</div>
              //   }
              // }, {
              //   title: "Enricher",
              //   width: 82,
              //   key: 'Enricher',
              //   render: (record) => {
              //     let success_count = record.enrichment_success;
              //     let error_count = record.enrichment_error;
              //     return record.data_type_processed == false ? <span className='right-align'>-</span> : <div style={{
              //       display: 'flex',
              //       flexDirection: 'column',
              //       alignItems: 'flex-end'
              //     }}>
              //       {record.file_processed == false && success_count > 0 ? <Link to={{

              //         pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
              //         search: queryString.stringify({
              //           success_type: 5
              //         })
              //       }}>
              //         <span className='right-align'>{formatMoney(success_count, 0)}</span>
              //       </Link> :
              //         <span className='right-align'>{formatMoney(success_count, 0)}</span>
              //       }
              //       {error_count > 0 && record.file_processed == false &&
              //         <Link to={{
              //           pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
              //           search: queryString.stringify({
              //             status: 'error',
              //             error_type: 5
              //           })
              //         }}>
              //           <span className='error-text'>{formatMoney(error_count, 0)} Errors</span>
              //         </Link>}</div>
              //   }
              // },
              // {
              //   title: "Transactions",
              //   width: 118,
              //   key: 'Transactions',
              //   dataIndex:'transferred_txns',
              //   render: (success_count=0, record) => {
              //     let error_count = record.txns_count-success_count;
              //     return record.data_type_processed==false? <span className='right-align'>-</span>: <div style={{
              //       display: 'flex',
              //       flexDirection: 'column',
              //       alignItems: 'flex-end'
              //     }}>
              //       {success_count>0?
              //       <Link  to={{
              //         pathname:`/activity/data-type/${record.data_type_id}/transactions`,
              //       }}>
              //       <span className='right-align'>{formatMoney(success_count, 0)}</span>
              //      </Link>
              //   :<span className='right-align'>{formatMoney(success_count,0)}</span> 
              //   }
              //       {error_count > 0 &&
              //         <Link  to={{
              //           pathname:record.file_processed==true?`/activity/data-type/${record.data_type_id}/nottransferredtransactions`:
              //           `/activity/data-type/${record.data_type_id}/files/${record.id}`
              //           ,
              //           search: queryString.stringify({
              //             // fetcher_response_id:record.fetcher_response_id,
              //             // dateFrom:record.file_processed==true?record.min_txn_date:null,
              //             // dateTo:record.file_processed==true?record.max_txn_date:null,
              //             parse_batch_id:record.file_processed==true?record.id:null,

              //           })
              //         }}>
              //           <span className='error-text'>{formatMoney(error_count, 0)} 
              //           {record.file_processed==true?" Queued":" Blocks"}</span>
              //         </Link>}</div>
              //   }

              // }
            ]
          },
          {
            title: "Packets",
            children: [
              {
                title: "Queued",
                width: 100,
                key: 'queued_packets',
                dataIndex: 'queued_packets',
                className: 'center-align',
                render: (value, record) => <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>{record.show_dash == true ? <span className='right-align'>-</span> : value > 0 ? <Link to={{
                  pathname: `/activity/data-type/${record.data_type_id}/packets`,
                  search: queryString.stringify({
                    transferred: 'false',
                    fetcher_response_id: record.fetcher_response_id
                  })
                }}> <span className='right-align'>{formatMoney(value, 0)}</span></Link> : <span className='right-align'>{formatMoney(value, 0)}</span>
                  }</div>
              },
              {
                title: "Transferred",
                width: 100,
                key: 'transferred_packets',
                dataIndex: 'transferred_packets',
                className: 'center-align',
                render: (value, record) => <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>{record.show_dash == true ? <span className='right-align'>-</span> : value > 0 ? <Link to={{
                  pathname: `/activity/data-type/${record.data_type_id}/packets`,
                  search: queryString.stringify({
                    transferred: 'true',
                    fetcher_response_id: record.fetcher_response_id
                  })
                }}> <span className='right-align'>{formatMoney(value, 0)}</span></Link> : <span className='right-align'>{formatMoney(value, 0)}</span>
                  }</div>

              },
              {
                title: "Total",
                width: 100,
                key: 'total_packets',
                dataIndex: 'total_packets',
                className: 'center-align',
                render: (value, record) => <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>{record.show_dash == true ? <span className='right-align'>-</span> :
                  value > 0 ? <Link to={{
                    pathname: `/activity/data-type/${record.data_type_id}/packets`,
                    search: queryString.stringify({
                      fetcher_response_id: record.fetcher_response_id
                    })
                  }}>  <span className='right-align'>{formatMoney(value, 0)}</span></Link> : <span className='right-align'>{formatMoney(value, 0)}</span>
                  }
                    <GetAppOutlined
                      style={{
                        position: "absolute",
                        right: 10,
                      }}
                      onClick={() => {
                        typeof props.onDownloadTransaction === 'function' && props.onDownloadTransaction(record)
                      }}
                      titleAccess="Download Transaction" className='basic-icon hand-cursor'
                    />
                  </div>
              }
            ]
          },



          // {
          //   title: "FILES COUNT",
          //   dataIndex: 'files_count',
          //   className: 'right-align',
          //   key: 'files_count',
          //   width: 100,
          //   render: (value, record) => (value == 0 || value == null) ? <span className='center-align'>{value == null ? "-" : value}</span>
          //     : <Link
          //       className='right-flex-child'
          //       to={{
          //         pathname: `/activity/data-type/${record.data_type_id}/files`,
          //         search: queryString.stringify({
          //           // dateFrom:moment(data.executed_at,"YYYY-MM-DD HH:mm:ss A").isValid()?moment(data.executed_at,"YYYY-MM-DD HH:mm:ss A").format("YYYY-MM-DD"):null,
          //           // dateTo:moment(data.executed_at,"YYYY-MM-DD HH:mm:ss A").isValid()?moment(data.executed_at,"YYYY-MM-DD HH:mm:ss A").add({day:1}).format("YYYY-MM-DD"):null,
          //           fetcher_response_id: record.fetcher_response_id
          //         })
          //       }}>{formatMoney(value, 0)}</Link>
          // },
          // {
          //   title: "PACKET COUNT",
          //   dataIndex: 'packets_count',
          //   className: 'right-align',
          //   key: 'packets_count',
          //   width: 110,
          //   render: (value, record) => (value == 0 || value == null) ? <span className='center-align'>{value == null ? "-" : value}</span>
          //     : <Link
          //       className='right-flex-child'
          //       to={{
          //         pathname: `/activity/data-type/${record.data_type_id}/packets`,
          //         search: queryString.stringify({
          //           // dateFrom:moment(data.executed_at,"YYYY-MM-DD HH:mm:ss A").isValid()?moment(data.executed_at,"YYYY-MM-DD HH:mm:ss A").format("YYYY-MM-DD"):null,
          //           // dateTo:moment(data.executed_at,"YYYY-MM-DD HH:mm:ss A").isValid()?moment(data.executed_at,"YYYY-MM-DD HH:mm:ss A").add({day:1}).format("YYYY-MM-DD"):null,
          //           fetcher_response_id: record.fetcher_response_id
          //         })
          //       }}>{formatMoney(value, 0)}</Link>
          // },
          // {
          //   title: "TXN COUNT",
          //   dataIndex: 'txns_count',
          //   className: 'right-align',
          //   key: 'txns_count',
          //   width: 100,
          //   render: (value, record) => (value == 0 || value == null || record.packets_count == 0 || record.packets_count == null) ? <span className='center-align hand-cursor' title="Packets not transferred yet">{value == null ? "-" : value}</span>
          //     : <Link className='right-flex-child' to={{
          //       pathname: `/activity/data-type/${record.data_type_id}/transactions`,
          //       search: queryString.stringify({
          //         dateFrom: record.min_txn_date,
          //         dateTo: record.max_txn_date,
          //         fetcher_response_id: record.fetcher_response_id
          //       })
          //     }}>{formatMoney(value, 0)}</Link>
          // },
          // {
          //   title: "STAGING",
          //   dataIndex: 'txns_count',
          //   className: 'right-align',
          //   key: 'txns_count',
          //   width: 100,
          //   render: (value, record) => (value == 0 || value == null || record.packets_count == 0 || record.packets_count == null) ? <span className='center-align hand-cursor' title="Packets not transferred yet">{value == null ? "-" : value}</span>
          //     : <Link className='right-flex-child' to={{
          //       pathname: `/activity/data-type/${record.data_type_id}/transactions`,
          //       search: queryString.stringify({
          //         dateFrom: record.min_txn_date,
          //         dateTo: record.max_txn_date,
          //         fetcher_response_id: record.fetcher_response_id
          //       })
          //     }}>{formatMoney(value, 0)}</Link>
          // },
          // {
          //   title: "Passed block",
          //   dataIndex: 'passed_block_count',
          //   className: 'right-align',
          //   key: 'passed_block_count',
          //   width: 100,
          //   render: (value, record) => (<div className='right-flex-child'>{formatMoney(value, 0)}</div>)
          // },
          // {
          //   title: "Total block",
          //   dataIndex: 'total_block_count',
          //   className: 'right-align',
          //   key: 'total_block_count',
          //   width: 100,
          //   render: (value, record) => (<div className='right-flex-child'>{formatMoney(value, 0)}</div>)
          // }
        ]}
      />}
    {<React.Fragment>
      <Divider style={{
        marginTop: 0, marginBottom: 0
      }} />
      <div style={{
        paddingBottom: 8,
        paddingTop: 8
      }}><Link to={`/activity/fetcher/responses/${data.fetcher_log_id}/${data.response_id}`}>
          <Button type='link' icon={<MenuOpenOutlined style={{
            transform: 'rotateZ(180deg)',
            marginRight: 8
          }} />} style={{
            display: 'flex',
            alignItems: 'center'
          }}>VIEW ALL</Button>
        </Link>
      </div>
    </React.Fragment>}

  </div>
}




// data_types = [
//   {
//     data_type: "ATM EJ"
// data_type_id: 2
// fetcher_response_id: 12283,
//     files: [A, B, C],
//     processed: true
//   },
//   {
//     data_type: "ATM EJ 2"
// data_type_id: 4
// fetcher_response_id: 3434,
//     files: [],
//     processed: false
//   }
// ]


// data_types_1 = [
//   {
//     data_type: "ATM EJ"
// data_type_id: 2
// fetcher_response_id: 12283,
//     files: A
//     processed: true
//   },
//   {
//     data_type: "ATM EJ"
// data_type_id: 2
// fetcher_response_id: 12283,
//     files: B
//     processed: true
//   },
//   {
//     data_type: "ATM EJ"
// data_type_id: 2
// fetcher_response_id: 12283,
//     files: C
//     processed: true
//   },
//   {
//     data_type: "ATM EJ 2"
// data_type_id: 4
// fetcher_response_id: 3434,
//     files: null or {},
//     processed: false
//   }
// ]